import { EXTERNAL_ROUTES } from "@/const/routes.constants"
import { ReadOutlined } from "@/icons"
import { LinkButton } from "@/molecules/LinkButton"

import type { DocumentationLinkProps } from "."

export const DocumentationLink = (props: DocumentationLinkProps) => {
  const {
    children,
    link,
    href = `${EXTERNAL_ROUTES.API_DOCS}${link}`,
    ...rest
  } = props

  return (
    <LinkButton
      type="link"
      size="small"
      icon={<ReadOutlined />}
      href={href}
      target="_blank"
      {...rest}
    >
      {children}
    </LinkButton>
  )
}
